export enum RoleType {
    SubaruUsers = "SubaruUsers",
    Admin = "Admin"
}